import { Pressed, Stack } from 'libs/ui';
import { CSSObject, styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const HeaderStyled = styled(Stack)(() => ({
  padding: '8px 16px',
  position: 'sticky',
  top: 0,
  zIndex: 1,
  backgroundColor: Colors.white,
}));

export const CloseButtonStyled = styled(Pressed)(() => ({
  '& svg path': {
    strokeWidth: 3,
  } as CSSObject,

  '&:hover': {
    '& svg': {
      color: Colors.hover,
    } as CSSObject,
  },
}));
